import React from 'react';

import {DropdownItem, DropdownMenu} from 'reactstrap';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {useCurrentUserState} from 'app/current-user/api';
import {UserMenuButton} from 'app/general/structures/SPFrame/SPHeader/UserMenu';
import {gt} from 'app/utils/i18n';

export const UserMenu = (): JSX.Element => {
  const currentUser = useCurrentUserState().data!;

  return (
    <UserMenuButton userData={currentUser}>
      <DropdownMenu>
        <DropdownItem tag={FullHTMLLink} key={1} html_url={'/'}>
          <i className="fa fa-fw fa-user-circle" />
          <span>{gt('My Account')}</span>
        </DropdownItem>
      </DropdownMenu>
    </UserMenuButton>
  );
};
